import React from 'react'
import { FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#32494b] to-[#3c585a] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Sahil Aherwar</h3>
        <p className="text-lg font-normal text-gray-400">
          Web Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
        For collaboration or inquiries, please don't hesitate to contact me. I look forward to connecting with you!
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+91 8433534072</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">sahilaherwar74658@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Contact me:</h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
              <a href='https://www.instagram.com/im_smiley_xb/'><FaInstagram /></a>
            </span>
            <span className="bannerIcon">
            <a href='https://x.com/aherwar_sahil?t=51L1vdaR83a_M5GCzs7cFw&s=09'><FaTwitter /></a>
            </span>
            <span className="bannerIcon">
            <a href='https://www.linkedin.com/in/sahil-aherwar/'><FaLinkedinIn /></a>
            </span>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft